import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadRelationVehicleSzltListFailed,
  loadRelationVehicleSzltListSuccessful,
  loadRelationVehicleSzltListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadRelationVehicleSzltList(action) {
  try {
    const {
      payload = {
      },
    } = action;

    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
      with_vehicle: 1,
      with_order_service: 1,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    yield put(loadRelationVehicleSzltListBegin());
    const url = `${BACKEND_URL}/registries/order-service-vehicle`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRelationVehicleSzltListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRelationVehicleSzltListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRelationVehicleSzltListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
